import { motion, AnimatePresence } from "framer-motion";
import React from 'react'
const animations = {
    initial: { opacity: 0, x: -10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 }
}
export default function AnimatedSidePopup({child, isOpen}) {
    return (
        <AnimatePresence>
            <motion.div
                key={isOpen}
                initial={{ x: "100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    // background: "#00000047",
                    zIndex: 999,
                    overflow: "auto",
                }}
            >
                {child}
            </motion.div>
        </AnimatePresence>
    );
}